export const ORGANIZATION_ENDPOINTS = {
  LIST: "/organization",
  CREATE: "/organization",
  UPDATE: (unitId) => `/organization/${unitId}`,
  DELETE: (unitId) => `/organization/${unitId}`,
  SET_STATUS: (unitId) => `/organization/${unitId}/status`,
  LOOKUPS: "/organization/lookups",
  NAMES: "/organization/names",
  TREE: "/organization/tree",
  HIERARCHY_ADMIN_ALL: "/organization/admin/org",
  IMPORT_TEMPLATE: "/organization/import/template",
  IMPORT_EXCEL: "/organization/import",
};
